<template>
  <div class="rate" v-if="rate.length > 0">
    <h3 v-if="!showOnlyAvarege">
      {{ title }}
      <v-tooltip bottom v-if="btnShow">
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            class="onHover"
            @click="$emit('clearRate')"
            >delete_forever
          </v-icon>
        </template>
        <span>{{ removeBtnText }}</span>
      </v-tooltip>
      <span v-if="count !== null">({{ count }})</span>
    </h3>
    <div v-if="!showOnlyAvarege">
      <div
        class="rating_items"
        :class="{ rating__avarege: !makeRate }"
        v-for="item in rate"
        :key="item.id"
      >
        <span v-if="!item.description">{{ item.name }}</span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">{{ item.name }}</span>
          </template>
          <span>{{ item.description }}</span>
        </v-tooltip>
        <v-rating
          v-model="item.rate"
          color="yellow darken-3"
          background-color="grey darken-1"
          empty-icon="$ratingFull"
          half-increments
          hover
          class="rating_star"
          rating__off
          :class="{ rating__off: !makeRate }"
          disabled
        />
      </div>
    </div>

    <div
      class="rating__avarege rating__off rating_items noHover"
      style="height: 25px !important"
      v-if='showAvarege'
    >
      <span>Средний балл</span>
      <v-rating
        v-model="avarege"
        color="yellow darken-3"
        background-color="grey darken-1"
        empty-icon="$ratingFull"
        half-increments
        hover
        class="rating_star avarege_star"
        disabled
      />
      <span v-if="avarageCount !== null"
        >{{ avarege.toFixed(1) }} (оценок {{ avarageCount }})</span
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  data: () => ({}),
  props: {
    rate: { type: Array, default: () => [], required: true },
    title: { type: String, default: "Оценка" },
    removeBtnText: { type: String, default: "Удалить" },
    btnShow: { type: Boolean, default: false },
    avarege: { type: Number, required: true },
    count: { type: Number, default: null },
    avarageCount: { type: Number, default: null },
    removeRole: { type: String, default: "Сотрудник" },
    makeRate: { type: Boolean, default: true },
    showOnlyAvarege: { type: Boolean, default: false },
    showAvarege:{type: Boolean, default: false}
  },
  computed: {},
};
</script>
<style lang="sass" scoped>
.rating_items
  display: flex
  justify-content: left
  align-items: center
  height: 22px
.rate
  // padding: 20px
.avarege_star
  transform: scale(1.08)
  padding-left: 20px
  button
    padding: 0px !important
</style>
